<section style="max-height:{show?2000:0}px;" id="section-work">
  <div on:click={close} class="title"></div>

  <h1>We make the incredible</h1>
  <h2>What we do with most of our time</h2>


  <div class="popup">
    <div class="section title">
      <div>Our projects</div>
      <div>0{selected+1}</div>
    </div>    
    <div class="section content">
      {#each projects as project,i}
        {#if i == selected}
          <Popup {dir} {project} />
        {/if}
      {/each}
    </div>
    <div class="section switch">
      {#each projects as project,i}
        <img alt={project.title} on:click={()=>{ select(i) }} src="/res/circle{i==selected?"":"-inactive"}.svg" />
      {/each}
    </div>

    <img on:click={prev} alt="Previous" class="arrow left" src="/res/left.svg" />
    <img on:click={next} alt="Next" class="arrow right" src="/res/right.svg" />
  </div>
</section>

<style type="text/scss">
section{
  & > .title{
    height:50vh;
    background-image:url('/res/title-work.svg');
    background-size:contain;
    background-repeat:no-repeat;
    background-position:50% 50%;
    min-height:50vh;
    cursor:pointer;
  }
  @media( orientation:portrait ){
    & > .title{
      height:130px;
      min-height:130px;
      margin-top:400px;      
    }
  }
  @media (max-aspect-ratio: 16/6) {
    & > .intro{
      width:110%;
      margin-left:-5%;
    }
  }
}

section{
  overflow:hidden;
  /*transition:max-height 0.6s ease-in-out;*/

  h1{ font-size: 60px; letter-spacing: -0.379747px; color: var(--titles); line-height:70px; padding-top:60px; }
  h2{ font-size: 22px; text-align: center; color: var(--titles); }

  .popup{
    background-color:var(--popup);
    max-width:980px;
    margin:0px auto;
    border-radius:15px;
    margin-top:30px;
    margin-bottom:80px;
    box-shadow: 0px 0px 25px -2px rgba(0,0,0,0.41);    
    position:relative;    
    .arrow{
      position:absolute;
      top:50%;      
      transform:translateY(-50%);
      cursor:pointer;
      &.left{ left:15px; }
      &.right{ right:15px; }
    }
    .title{
      border-bottom:1px solid #9acaeb;
      color:#9acaeb;
      padding:20px;
      & div {
        width:50%;
        text-align:left;
      }
    }
    .content{ min-height:400px; }    
    .switch{
      padding-bottom:40px;
      display:flex;
      justify-content:center;      
      img{ margin-left:10px; margin-right:10px; cursor:pointer; }
    }
    .section{
      display:flex;
      align-items:center;
    }
  }
}
@media( max-width:1024px ){
  section{
    .popup{
      width:90%;
      .title div:last-child{
        text-align:right;
      }
      .arrow{
        &.left{ left:5px; }
        &.right{ right:5px; }
      }
    }
    h1{ padding:2px 20px; margin-top:20px; font-size:40px; line-height:40px; }
  }  
}
</style>

<script>
import { projects } from '../stores/projects'

import Popup from './Popup.svelte'

export let show

let dir = 1
let selected = 0
const select = id => {
  dir = id > selected ? 1 : -1
  selected = id
}
const next = () => {
  dir = 1
  selected++
  if( selected > projects.length - 1 ) selected = 0
}
const prev = () => {
  dir = -1
  selected--  
  if( selected < 0 ) selected = projects.length-1
}

import { section } from '../stores/navigation'
const close = () => {
  section.set('')
}
</script>